import Image from "next/image";

export default function EagleLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} style={{ height: "inherit" }}>
      {/* Brass medallion mark */}
      <div className="relative shrink-0">
        <Image
          src="/images/logo-eagle.png"
          alt="Eagle Chimney Service"
          width={55}
          height={48}
          className="h-10 lg:h-12 w-auto object-contain"
          priority
        />
      </div>
      {/* Serif wordmark + tracked subtitle */}
      <div className="flex flex-col leading-none">
        <span className="font-display text-2xl lg:text-3xl font-bold text-[#7A5500] tracking-tight">
          Eagle
        </span>
        <span className="text-[9px] lg:text-[10px] font-bold tracking-[0.32em] text-[#0A0A0A] uppercase mt-1.5">
          Chimney&nbsp;Service
        </span>
      </div>
    </div>
  );
}
